import React from 'react';

const Credits = () => {
    const handleDivClick = () => {
        window.open('https://asylum.fr', '_blank');
    };

    return (
        <div id='creditsAsy' onClick={handleDivClick}>
            <div className='creditsTitle'>Powered by</div>
            <div className='creditsImage'>
                <img src={`logo_asy.png`} alt="Asylum Logo"></img>
            </div>
        </div>
    )
}


export default Credits;
